import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { map, take } from 'rxjs/operators';

import { ConfigurationService } from '@shared/services/configuration.service';
import { AuthConfigService } from './auth-config.service';
import { AuthService } from './auth.service';

export function loadEnvConfiguration(authService: AuthService, configurationService: ConfigurationService) {
  return () => configurationService.initialized$.pipe(
    take(1),
    map(_ => authService.initAuth())
  ).toPromise();
}

@NgModule({
  imports: [HttpClientModule, OAuthModule.forRoot({
    resourceServer: {
      sendAccessToken: false
    }
  })],
  providers: [
    AuthConfigService,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadEnvConfiguration,
      deps: [AuthService, ConfigurationService],
      multi: true
    }
  ]
})
export class AuthConfigModule {
}
